<template>
  <b-dropdown-divider test-id="al-dropdown-divider" />
</template>

<script>
import BdropdownDivider from 'bootstrap-vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BdropdownDivider
  }
};
</script>
